/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PartnerProfileSearchRequest } from '../models/PartnerProfileSearchRequest';
import type { PartnerProfileSearchResponse } from '../models/PartnerProfileSearchResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PartnerProfilesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns PartnerProfileSearchResponse OK
     * @throws ApiError
     */
    public searchProfile({
        requestBody,
    }: {
        requestBody: PartnerProfileSearchRequest,
    }): CancelablePromise<PartnerProfileSearchResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/partner-apis/profiles/search',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
